import React, { useEffect, useState } from "react";
import { TextField, Button, Typography, Grid, Select, MenuItem, FormControl, Box } from "@mui/material";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { useLocation, useNavigate } from "react-router-dom";
import { uploadImage } from "../uploadImageToBackBlaze";
import { isURL } from "../utils/utility";
import CancelIcon from '@mui/icons-material/Cancel';
import CustomSnackbar from '../Components/CustomSnackBar';
import Loader from "../Components/Loader";




const logoContainer = {
  border: "1px dashed #ccc",
  width: "100px",
  height: "100px",
  display: "flex",
  flexDirection: 'column',
  justifyContent: "center",
  alignItems: "center",
  cursor: "pointer",
  marginTop: "5px",
  position: "relative",
  borderRadius: "8px",
}

const screenshotContainer = {
  display: "flex",
  cursor: "pointer",
  marginTop: "5px",
  flexWrap: "wrap",
}

const screenshotWrapper = {
  position: "relative",
  width: "100px",
  height: "100px",
  border: "1px dashed #ccc",
  margin: "0 5px",
  cursor: "pointer",
  borderRadius: "8px",
}

const textFieldStyles =
{
  marginTop: '5px',
  marginBottom: '20px',
  '& .MuiInputBase-input': {
    padding: '5px 10px',
    fontSize: '12px',
    background: '#f5f5f5',
    borderRadius: '4px',
  },
  '& .MuiInputBase-multiline': {
    padding: '0', // Padding for multiline input
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none', // remove border

  },

}

const labelStyles = {
  fontSize: '13px',
  marginBottom: '5px',
  fontWeight: 500,
  color: theme => theme.palette.primary.textColor

};


const screenshotLabel = {
  position: "relative",
  display: "flex",
  width: "100px",
  height: "100px",
  border: "1px dashed #ccc",
  margin: "0 5px",
  cursor: "pointer",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  borderRadius: "8px",
}

const loaderStyle = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100px",
  width: "100px",
}




const StoreListingPage = (props) => {
  const [inputsData, setInputsData] = useState({
    title: "",
    summary: "",
    description: "",
    packageUrl: "",
    category: "",
    templateName: "",
  });
  const [logo, setLogo] = useState(null);
  const [screenshots, setScreenshots] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  const [showLoaderLogo, setShowLoaderLogo] = React.useState(false);
  const [showLoaderScreenShot, setShowLoaderScreenShot] = React.useState(false);
  const [disabled, setDisabled] = React.useState(false);
  const [toDeleteItem, setTodeleteItem] = React.useState('');
  const [logoAvailable, setLogoAvailable] = useState(false);
  const [newTemplate, setNewTemplate] = useState(false);
  const [error, setError] = useState('');
  const [logoName, setLogoName] = useState("");
  const [downloadUrl, setDownloadUrl] = useState('');
  const [errors, setErrors] = useState({ packageUrl: "" });
  const bucketURLS = props.bucketURLS || {};



  useEffect(() => {
    if(bucketURLS.portal){
      setDownloadUrl(bucketURLS.portal)
    }
  }, [bucketURLS])



  const categoriesData = props?.categoriesData;


  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const { hd_id, publishDate, componentName, templateName } = location.state;
  const packageInfo = location.state?.packageInfo

  useEffect(() => {
    // const parsedInfo = JSON.parse(packageInfo?.details?.info ?? "{}");
    const parsedInfo = packageInfo?.details?.portal_data ?? {}

    const data = {
      title: componentName,
      summary: packageInfo?.details?.info?.summary,
      description: parsedInfo?.description,
      packageUrl: parsedInfo?.videoUrl,
      category: packageInfo?.details?.categoryName,
      templateName: packageInfo?.details?.templateName,
    };
    if (!packageInfo?.details?.templateName) {
      setNewTemplate(true)
    }
    const logo = parsedInfo?.logo;
    const images = parsedInfo?.images?.filter(item => typeof item === 'string');
    const logoName = packageInfo?.logo?.fileName;
    setLogoName(logoName)
    setLogo(logo);
    if (logo) {
      setLogoAvailable(true)
    }
    setInputsData(data);
    setScreenshots(images ? images : []);
  }, [packageInfo]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "packageUrl") {
      const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com\/watch\?v=|youtu\.be\/)[\w-]{11}/;
      if (value && !youtubeRegex.test(value)) {
        setErrors({ ...errors, packageUrl: "Please enter a valid YouTube URL" });
      } else {
        setErrors({ ...errors, packageUrl: "" });
      }
    }

    setInputsData({ ...inputsData, [name]: value });
  };

  const handleLogoChange = async (e) => {
    const file = e.target.files[0];
    if (file && file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = async (event) => {
        const image = new Image();
        image.src = event.target.result;

        image.onload = async () => {
          if (file.size > 2 * 1024 * 1024) {
            alert("File size must be less than 2 MB");
            return;
          } else {
            const url = logo;
            const fileIdIndex = url && url.indexOf("fileId=");
            setShowLoaderLogo(true);
            if (fileIdIndex !== -1 && logoAvailable) {
              // const fileId = url && url.substring(fileIdIndex + 7);
              await callDeleteImageApi({
                fileName: logoName,
              });
            }


            const data = await uploadImage(componentName, templateName ? templateName : inputsData.templateName, hd_id, file, 'logo.png');
            if (!(data && data.fileName)) {
              setShowLoaderLogo(false);
              alert("Something went wrong. Please try again.");
            } else {
              const { fileName } = data;
              setLogo(fileName);
              setShowLoaderLogo(false);
            }
          }
        };
      };
    } else {
      alert('Please select a valid image')
    }
  };


  const handleScreenshotChange = async (e) => {
    const file = e.target.files[0];
    if (file && file.type.startsWith('image/')) {
      setShowLoaderScreenShot(true);
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = async (event) => {
        const image = new Image();
        image.src = event.target.result;

        image.onload = async () => {
          if (file.size > 2 * 1024 * 1024) {
            setShowLoaderScreenShot(false);
            alert("File size must be less than 2 MB");
            return;
          } else {
            if (screenshots.length < 5) {
              // const dataURI = await readFileAsDataURL(file);
              const data = await uploadImage(
                componentName, templateName ? templateName : inputsData.templateName, hd_id,
                file,
                `carouselImage.png`
              );
              if (!(data && data.fileName)) {
                alert("Error Occurred!");
                setShowLoaderScreenShot(false);
              } else {
                const { fileName } = data;
                setScreenshots([
                  ...screenshots,
                  fileName,
                ]);
                setShowLoaderScreenShot(false);
              }
            }
          }
        };
      }
    } else {
      alert('Please select a valid image')
    }
  };

  const callDeleteImageApi = async (image) => {
    const params = new URLSearchParams();
    params.append('componentName', componentName);
    params.append('templateName', templateName);
    const url = `/nodeapi/fileUploads/deleteStoreImage?${params.toString()}`;
    const payload = {
      fileName: image.fileName ? image.fileName : image,
    };
    const headers = {
      "Content-Type": "application/json",
    };

    const requestOptions = {
      method: "POST",
      headers: headers,
      body: JSON.stringify(payload),
      credentials: 'include'
    };

    return fetch(url, requestOptions).then((response) => {
      if (response && response.status === 200) {
        return true;
      } else {
        return false;
      }
    });
  };

  const handleRemoveScreenshot = async (index, screenshot) => {
    const updatedScreenshots = [...screenshots];
    const toDelete = updatedScreenshots[index];
    setTodeleteItem(toDelete)
    updatedScreenshots[index] = "";
    await setShowLoaderScreenShot(true);
    setScreenshots(updatedScreenshots);
    callDeleteImageApi(screenshot)
      .then((result) => {
        if (result) {
          updatedScreenshots.splice(index, 1);
          setShowLoaderScreenShot(false);
          setTodeleteItem('')
        } else {
          updatedScreenshots[index] = toDelete;
          setScreenshots(updatedScreenshots);
          alert("failed to remove! Error occurred");
          setShowLoaderScreenShot(false);
          setTodeleteItem('')
        }
      })
      .catch((err) => {
        updatedScreenshots[index] = toDelete;
        setScreenshots(updatedScreenshots);
        alert("failed to remove! Error occurred");
        setShowLoaderScreenShot(false);
        setTodeleteItem('')
      });
  };

  const handleUpdate = () => {
    setDisabled(true);

    let url = ''
    if (!newTemplate) {
      const params = new URLSearchParams();
      params.append('componentName', componentName);
      params.append('existingTemplateName', templateName);
      url = `/nodeapi/portal/update-component?${params.toString()}`;
    } else {
      const params = new URLSearchParams();
      params.append('componentName', componentName);
      url = `/nodeapi/portal/create-template?${params.toString()}`
    }
    const payload = {
      info: {
        logo: logo,
        summary: inputsData.summary,
        videoUrl: inputsData.packageUrl,     
        description: inputsData.description,
        images: screenshots,

      },
      categoryName: inputsData.category,
      templateName: inputsData.templateName
    };
    const headers = {
      "Content-Type": "application/json",
    };

    const requestOptions = {
      method: "POST",
      headers: headers,
      body: JSON.stringify(payload),
      credentials: "include",
    };

    fetch(url, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result && result.success && result.success === 1) {
          setOpen(true);
          setTimeout(() => {
            navigate(
              `/package?componentName=${componentName}&templateName=${inputsData.templateName}`,
              {
                state: {
                  hd_id: hd_id,
                  componentName: componentName,
                  publishDate: publishDate,
                  templateName: inputsData.templateName
                },
              }
            );
          }, 2000);
        } else {
          setError(result?.errMsg);
          setOpen(true)
        }
        setDisabled(false);
      })
      .catch((error) => {
        console.error("Error:", error);
        setOpen(true);
        setError(error.message ? error.message : error);
        setDisabled(false);
      });
  };



  return (
    <Box sx={{ padding: "0 20px" }}>
      {
        inputsData.templateName ? <Grid container mb={3}>
          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
            }}
          >

          </Grid>
        </Grid> : null
      }
      <Grid container mb={3}>
        <Grid item xs={12}>
          <Typography variant="h6" mb={2} sx={{ fontWeight: 600 }} gutterBottom>
            Package Details
          </Typography>
          <Typography sx={labelStyles}>Component Name</Typography>
          <TextField
            // label="Component Name"
            variant="outlined"
            name="title"
            value={inputsData.title}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
            disabled={true}
            sx={textFieldStyles}
          />
          <Typography sx={labelStyles}>Template Name</Typography>
          <TextField
            // label="Template Name"
            variant="outlined"
            name="templateName"
            value={inputsData.templateName}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
            sx={textFieldStyles}
          />
          <Typography sx={labelStyles}>Summary</Typography>
          <TextField
            // label="Summary"
            variant="outlined"
            name="summary"
            value={inputsData.summary}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
            sx={textFieldStyles}
          />
          <Typography sx={labelStyles}>Description</Typography>
          <TextField
            variant="outlined"
            name="description"
            value={inputsData.description}
            onChange={handleInputChange}
            multiline
            rows={10}
            fullWidth
            margin="normal"
            placeholder="Your ReadMe.md goes here by default"
            sx={textFieldStyles}
          />
        </Grid>
      </Grid>
      <Grid container mb={3}>
        <Grid item xs={12}>
          <Typography variant="h6" mb={2} sx={{ fontWeight: 600 }} gutterBottom>
            Graphic assets
          </Typography>
          <div style={{ marginBottom: "10px", display: "flex", flexWrap: "wrap" }}>
            <div style={{ marginRight: '60px' }}><Typography sx={labelStyles}>Logo:</Typography>
              <Box sx={logoContainer}>
                {!logo && !showLoaderLogo ? (
                  < >
                    <AddCircleOutlineIcon sx={(theme) => ({
                      marginBottom: '5px',
                      color: newTemplate ? theme.palette.action.disabled : 'inherit',
                    })} />
                    <Typography variant="caption" sx={(theme) => ({
                      color: newTemplate ? theme.palette.action.disabled : 'inherit',
                    })}>Click to add logo</Typography>
                  </>
                ) : showLoaderLogo ? (
                  <Box sx={loaderStyle}>
                    {" "}
                    <Loader />
                  </Box>
                ) : (
                  <img
                    src={isURL(logo) ? logo : `${downloadUrl}/${logo}`}
                    onError={() => setLogoAvailable(false)}
                    alt="Logo"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                      borderRadius: "8px",
                    }}
                  />
                )}

                <input
                  type="file"
                  accept="image/*"
                  disabled={newTemplate}
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    opacity: 0,
                    cursor: newTemplate ? 'default' : 'pointer',

                  }}
                  onChange={handleLogoChange}

                />
              </Box>
            </div>
            <div>
              <Typography sx={labelStyles}>Screenshots:</Typography>
              <Box sx={screenshotContainer}>
                {screenshots.map((screenshot, index) => (
                  <Box key={index} sx={screenshotWrapper}>
                    {screenshot ? (
                      <img
                        src={`${downloadUrl}/${screenshot}`}
                        alt={`Screenshot ${index + 1}`}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          borderRadius: "8px",
                        }}
                      />
                    ) : (
                      <div className="loader-div">
                        {" "}
                        <Loader />
                      </div>
                    )}
                    <CancelIcon sx={{
                      position: "absolute",
                      top: "2px",
                      right: "2px",
                      zIndex: 1,
                      background: "#fff",
                      borderRadius: '50%'
                    }}
                      onClick={async () => {
                        handleRemoveScreenshot(index, screenshot);
                      }} />
                  </Box>
                ))}
                {screenshots.length < 5 && !toDeleteItem &&
                  (showLoaderScreenShot ? (
                    <div className="loader-div">
                      {" "}
                      <Loader />
                    </div>
                  ) : (
                    <Box sx={screenshotLabel}>
                      <AddCircleOutlineIcon sx={(theme) => ({
                      marginBottom: '5px',
                      color: newTemplate ? theme.palette.action.disabled : 'inherit',
                    })} />
                      <Typography variant="caption" sx={(theme) => ({
                      color: newTemplate ? theme.palette.action.disabled : 'inherit',
                    })}>Click to add screenshot</Typography>
                      <input
                        type="file"
                        accept="image/*"
                        disabled={newTemplate}
                        style={{
                          position: 'absolute',
                          width: '100%',
                          height: '100%',
                          opacity: 0,

                          cursor: newTemplate ? 'default' : 'pointer',
                        }}
                        onChange={handleScreenshotChange}
                      />
                    </Box>
                  ))}
              </Box>
            </div>
          </div>
        </Grid>
      </Grid>
      <Grid container mb={3}>

        <Grid item xs={12}>
          <Typography variant="h6" mb={2} sx={{ fontWeight: 600 }} gutterBottom>
            Additional Information
          </Typography>
          <Typography sx={labelStyles}>Category</Typography>

          <FormControl fullWidth mb={2}>
            <Select
              id="demo-simple-select"
              value={inputsData.category}
              // label="Select category"
              name="category"
              onChange={handleInputChange}
              sx={{
                margin: '5px 0 10px 0',
                '& .MuiInputBase-input': {
                  padding: '5px 10px',
                  background: '#f5f5f5',
                  fontSize: '12px'

                },
                '& .MuiOutlinedInput-notchedOutline': {
                  border: 'none',
                },

              }}
            >
              {
                categoriesData.map(item => {
                  return <MenuItem value={item.categoryName}>{item.categoryName}</MenuItem>

                })
              }
            </Select>
          </FormControl>
          <Typography sx={labelStyles}>Video Url</Typography>
          <TextField
            // label="Video url"
            variant="outlined"
            name="packageUrl"
            value={inputsData.packageUrl}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
            sx={textFieldStyles}
            error={!!errors.packageUrl}
            helperText={errors.packageUrl}
          />

        </Grid>
      </Grid>
      <Grid container mb={5}>
        <Grid
          item
          xs={12}
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <Button
            variant="contained"
            size="small"
            onClick={() => handleUpdate()}
            sx={{
              background: "#f05f40"
            }}
            disabled={
              !inputsData.templateName ||
              disabled ||
              Object.values(errors).some(error => error)
            }
          >
            {
              newTemplate ? 'Create' : 'Update'
            }
          </Button>
        </Grid>
      </Grid>

      <CustomSnackbar
        open={open}
        handleClose={handleClose}
        error={error}
        message={newTemplate ? 'Template Created SuccessFully!' : 'Package Updated SuccessFully!'}

      />


    </Box>
  );
};

export default StoreListingPage;
